import { xBaseTheme } from "@eisinc/XDL/types";

export default {
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: [0, 481, 769, 1025, 1441],
    maxWidths: [480, 768, 1024, 1440, 1440],
} as xBaseTheme["breakpoints"];
